import { FC } from 'react';
import PageLayout from '@/components/ui/PageLayout/PageLayout.tsx';
import { useTranslation } from 'react-i18next';

type ProjectsPageProps = {};

const ProjectsPage: FC<ProjectsPageProps> = () => {
  const { t } = useTranslation();

  return <PageLayout name={t('projectsPage.title')}>Projects Page</PageLayout>;
};

export default ProjectsPage;
